import { requestJson } from './requestJson';

// Deletes one of the signed-in creator's own tests. Authority is the session
// cookie the browser sends automatically — no key is passed and none is accepted.
export async function deleteMyTest(testId: string): Promise<{ deleted: boolean }> {
  return await requestJson(`/api/my/tests/${encodeURIComponent(testId)}`, { method: 'DELETE' });
}
